var API_BASE = 'https://xn--wimax-lu8k074r.com/api/review_list';
var API_SINGLE = 'https://xn--wimax-lu8k074r.com/api/review';
var API_KEYS = ['prefecture', 'house_type', 'occupation', 'reason', 'router', 'purpose', 'keyword'];

/**
 * 表示ラベル変換テーブル
 */
var LABEL_MAP = {
    house_type: {
        'マンション': 'マンション / アパート',
        '戸建て': '戸建て'
    },
    occupation: {
        '会社員、会社役員': '会社員',
        '経営者': '経営者',
        'パート/アルバイト/派遣': 'パート/アルバイト/派遣',
        '自営業': '自営業',
        '学生専門職': '学生',
        '専業主婦': '専業主婦',
        'その他': 'その他'
    },
    reason: {
        '料金': '料金の安さ',
        'キャッシュバック': 'キャッシュバック',
        '容量': 'データ容量無制限',
        '通信速度': '通信速度',
        '端末': '端末代無料',
        'エリア': '通信エリア',
        '継続': '以前から利用していた',
        '紹介': '家族・知人の紹介',
        'ネット': '評判・口コミが良かった',
        '工事': '工事不要',
        'その他': 'その他'
    },
    router: {
        'mobile': 'モバイルルーター',
        'DOCK01': 'DOCK 5G',
        'NC03': 'NC03',
        'X12': 'X12',
        'X11': 'X11',
        'SCR01': 'SCR01',
        'home': 'ホームルーター',
        'L13': 'L13',
        'L12': 'L12',
        'L11': 'L11'
    },
    purpose: {
        '動画視聴': '動画視聴',
        'テレワーク': 'テレワーク',
        'オンラインゲーム': 'オンラインゲーム',
        '引越し・繋ぎ': '引越し・繋ぎ',
        '車内利用': '車内利用',
        '一人暮らし': '一人暮らし',
        '店舗・ビジネス利用': '店舗・ビジネス利用',
        '乗り換え': '乗り換え',
        '入院': '入院'
    },
    prefecture: {
        '北海道': '北海道', '青森県': '青森県', '岩手県': '岩手県', '宮城県': '宮城県',
        '秋田県': '秋田県', '山形県': '山形県', '福島県': '福島県', '茨城県': '茨城県',
        '栃木県': '栃木県', '群馬県': '群馬県', '埼玉県': '埼玉県', '千葉県': '千葉県',
        '東京都': '東京都', '神奈川県': '神奈川県', '新潟県': '新潟県', '富山県': '富山県',
        '石川県': '石川県', '福井県': '福井県', '山梨県': '山梨県', '長野県': '長野県',
        '岐阜県': '岐阜県', '静岡県': '静岡県', '愛知県': '愛知県', '三重県': '三重県',
        '滋賀県': '滋賀県', '京都府': '京都府', '大阪府': '大阪府', '兵庫県': '兵庫県',
        '奈良県': '奈良県', '和歌山県': '和歌山県', '鳥取県': '鳥取県', '島根県': '島根県',
        '岡山県': '岡山県', '広島県': '広島県', '山口県': '山口県', '徳島県': '徳島県',
        '香川県': '香川県', '愛媛県': '愛媛県', '高知県': '高知県', '福岡県': '福岡県',
        '佐賀県': '佐賀県', '長崎県': '長崎県', '熊本県': '熊本県', '大分県': '大分県',
        '宮崎県': '宮崎県', '鹿児島県': '鹿児島県', '沖縄県': '沖縄県'
    }
};

/**
 * フィルター定義 (表示順)
 */
var FILTER_CONFIG = [
    { key: 'router',     label: '機種' },
    { key: 'purpose',    label: '利用用途' },
    { key: 'house_type', label: '住居タイプ' },
    { key: 'prefecture', label: '都道府県' },
    { key: 'occupation', label: '職業' },
    { key: 'reason',     label: '選択理由' }
];

/**
 * ラベル変換 (テーブルにあれば変換、なければそのまま返す)
 */
function mapLabel(field, value) {
    if (!value) return '';
    if (LABEL_MAP[field] && LABEL_MAP[field][value] !== undefined) {
        return LABEL_MAP[field][value];
    }
    return value;
}

/**
 * コンテナの data-* 属性からベースパラメータを構築
 */
function buildBaseParams(container) {
    var params = new URLSearchParams();
    API_KEYS.forEach(function(key) {
        params.append(key, container.dataset[key] || '');
    });
    return params;
}

/**
 * APIを叩いてJSONを返す
 */
function fetchReviews(container, offset, limit) {
    var params = buildBaseParams(container);
    if (limit)  params.append('limit', limit);
    if (offset) params.append('offset', offset);
    return fetch(API_BASE + '?' + params.toString(), {
        headers: { 'X-API-Key': 'xAuZGVg8eeY6kd+CYlrptsBu7Kx7Av0cdm4L6nAsoGM=' }
    })
        .then(function(response) {
            if (!response.ok) throw new Error('ネットワークエラーが発生しました');
            return response.json();
        });
}

document.addEventListener('DOMContentLoaded', function() {
    var containers = document.querySelectorAll('.review-api-container');

    containers.forEach(function(container) {
        var limit = container.dataset.limit || '';
        var offset = container.dataset.offset || '';

        fetchReviews(container, offset, limit)
            .then(function(data) {
                renderData(container, data);
            })
            .catch(function(error) {
                container.innerHTML = '<p class="error-msg">データの取得に失敗しました。</p>';
                console.error('Fetch error:', error);
            });
    });

    // 単一口コミカード [review_card id="xxx"]
    var singleCards = document.querySelectorAll('.review-card-single');
    singleCards.forEach(function(container) {
        var id = container.dataset.reviewId;
        fetch(API_SINGLE + '?id=' + id, {
            headers: { 'X-API-Key': 'xAuZGVg8eeY6kd+CYlrptsBu7Kx7Av0cdm4L6nAsoGM=' }
        })
        .then(function(response) {
            if (!response.ok) throw new Error('ネットワークエラーが発生しました');
            return response.json();
        })
        .then(function(item) {
            container.innerHTML = '';
            var template = document.getElementById('review-card-template');
            container.appendChild(createCard(template, item, ''));
        })
        .catch(function(error) {
            container.innerHTML = '<p class="error-msg">データの取得に失敗しました。</p>';
            console.error('Fetch error:', error);
        });
    });
});

/**
 * 数値スコアを星文字列に変換
 */
function renderStars(score) {
    const num = parseFloat(score) || 0;
    var rounded = Math.round(num);
    return '★'.repeat(rounded) + '☆'.repeat(5 - rounded);
}

/**
 * APIレスポンスを描画
 */
function renderData(container, responseJson) {
    var template = document.getElementById('review-card-template');
    var reviews = responseJson.data;

    // コンテナをクリア
    container.innerHTML = '';

    // --- ヘッダー: タイトル + データ件数 ---
    var header = document.createElement('div');
    header.className = 'review-header';
    header.innerHTML =
        '<h2 class="review-header__title">' + (container.dataset.title || '口コミ') + '</h2>' +
        '<div class="review-header__count">データ数: ' + (responseJson.total_count || 0).toLocaleString() + '件</div>';
    container.appendChild(header);

    // --- フィルターセレクトボックス ---
    var filtersEl = document.createElement('div');
    filtersEl.className = 'review-filters';

    FILTER_CONFIG.forEach(function(cfg) {
        var currentVal = container.dataset[cfg.key] || '';
        var options = LABEL_MAP[cfg.key] || {};

        var filterDiv = document.createElement('div');
        filterDiv.className = 'review-filter';

        var label = document.createElement('span');
        label.className = 'review-filter__label';
        label.textContent = cfg.label;
        filterDiv.appendChild(label);

        var select = document.createElement('select');
        select.dataset.key = cfg.key;

        // 「すべて」オプション
        var defaultOpt = document.createElement('option');
        defaultOpt.value = '';
        defaultOpt.textContent = 'すべて';
        select.appendChild(defaultOpt);

        Object.keys(options).forEach(function(val) {
            var opt = document.createElement('option');
            opt.value = val;
            opt.textContent = options[val];
            if (val === currentVal) opt.selected = true;
            select.appendChild(opt);
        });

        select.addEventListener('change', function() {
            container.dataset[cfg.key] = select.value;
            container.dataset.offset = '';
            container.innerHTML = '<p class="loading-msg">データを読み込み中...</p>';
            var limit = container.dataset.limit || '';
            fetchReviews(container, '', limit)
                .then(function(data) {
                    renderData(container, data);
                })
                .catch(function(error) {
                    container.innerHTML = '<p class="error-msg">データの取得に失敗しました。</p>';
                    console.error('Fetch error:', error);
                });
        });

        filterDiv.appendChild(select);
        filtersEl.appendChild(filterDiv);
    });

    container.appendChild(filtersEl);

    // データが空の場合はヘッダー+フィルターを残して終了
    if (!Array.isArray(reviews) || reviews.length === 0) {
        var emptyMsg = document.createElement('p');
        emptyMsg.className = 'error-msg';
        emptyMsg.textContent = 'レビューはまだありません。';
        container.appendChild(emptyMsg);
        return;
    }

    // --- 口コミ評価サマリー ---
    var totalAvg = parseFloat(responseJson.rating_total_average) || 0;
    var speedAvg = parseFloat(responseJson.rating_speed_average) || 0;
    var costAvg  = parseFloat(responseJson.rating_cost_average) || 0;

    // 星分布
    var dist = responseJson.rating_total_distribution || {};
    var star5 = dist['5'] || 0;
    var star4 = dist['4'] || 0;
    var star3 = dist['3'] || 0;
    var star2 = dist['2'] || 0;
    var star1 = dist['1'] || 0;

    var summaryTitle = document.createElement('h3');
    summaryTitle.className = 'review-section-title';
    summaryTitle.textContent = '口コミ評価';
    container.appendChild(summaryTitle);

    var summary = document.createElement('div');
    summary.className = 'review-summary';
    summary.innerHTML =
        '<div class="review-summary__grid">' +
            // 左: 総合満足度
            '<div>' +
                '<span class="review-summary__overall-label">総合満足度</span>' +
                '<div class="review-summary__overall-rating">' +
                    '<span class="review-summary__stars-large">' + renderStars(totalAvg) + '</span>' +
                    '<span class="review-summary__score-large">' + totalAvg.toFixed(1) + '</span>' +
                '</div>' +
            '</div>' +
            // 中央: 星分布グラフ
            '<div class="review-summary__distribution">' +
                buildBarHTML(5, star5) +
                buildBarHTML(4, star4) +
                buildBarHTML(3, star3) +
                buildBarHTML(2, star2) +
                buildBarHTML(1, star1) +
            '</div>' +
            // 右: 項目別満足度
            '<div class="review-summary__categories">' +
                // SP版
                '<span class="review-summary__categories-title">項目別満足度</span>' +
                '<div class="review-cat-sp">' +
                    '<div class="review-cat-sp__header">通信速度</div>' +
                    '<div class="review-cat-sp__value">' +
                        '<span class="review-cat-sp__stars">' + renderStars(speedAvg) + '</span>' +
                        '<span class="review-cat-sp__score">' + speedAvg.toFixed(1) + '</span>' +
                    '</div>' +
                    '<div class="review-cat-sp__header">月額料金</div>' +
                    '<div class="review-cat-sp__value">' +
                        '<span class="review-cat-sp__stars">' + renderStars(costAvg) + '</span>' +
                        '<span class="review-cat-sp__score">' + costAvg.toFixed(1) + '</span>' +
                    '</div>' +
                '</div>' +
                // PC版
                '<div class="review-cat-pc">' +
                    '<div class="review-cat-pc__head">' +
                        '<div>項目別満足度</div>' +
                        '<div>平均評価</div>' +
                    '</div>' +
                    '<div class="review-cat-pc__row">' +
                        '<div class="review-cat-pc__label">通信速度</div>' +
                        '<div class="review-cat-pc__value">' +
                            '<span class="review-cat-pc__stars">' + renderStars(speedAvg) + '</span>' +
                            '<span class="review-cat-pc__score">' + speedAvg.toFixed(1) + '</span>' +
                        '</div>' +
                    '</div>' +
                    '<div class="review-cat-pc__row">' +
                        '<div class="review-cat-pc__label">月額料金</div>' +
                        '<div class="review-cat-pc__value">' +
                            '<span class="review-cat-pc__stars">' + renderStars(costAvg) + '</span>' +
                            '<span class="review-cat-pc__score">' + costAvg.toFixed(1) + '</span>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>';
    container.appendChild(summary);

    // --- 口コミ一覧ヘッダー ---
    var listHeader = document.createElement('div');
    listHeader.className = 'review-list-header';
    listHeader.innerHTML =
        '<h3 class="review-section-title" style="margin-bottom:0">口コミ一覧</h3>' +
        '<span class="review-list-header__sort">新着順</span>';
    container.appendChild(listHeader);

    // --- キーワード検索 ---
    var searchEl = document.createElement('div');
    searchEl.className = 'review-search';
    var searchInput = document.createElement('input');
    searchInput.type = 'text';
    searchInput.className = 'review-search__input';
    searchInput.placeholder = '口コミをキーワード検索(例: zoom、SNS...)';
    searchInput.value = container.dataset.keyword || '';
    var searchBtn = document.createElement('button');
    searchBtn.type = 'button';
    searchBtn.className = 'review-search__btn';
    searchBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11" cy="11" r="7" stroke="#6b7280" stroke-width="2"/><path d="M16 16L21 21" stroke="#6b7280" stroke-width="2" stroke-linecap="round"/></svg>';

    function executeSearch() {
        container.dataset.keyword = searchInput.value.trim();
        container.dataset.offset = '';
        var listEl = container.querySelector('.review-list');
        if (!listEl) return;
        listEl.innerHTML = '<p class="loading-msg">データを読み込み中...</p>';
        var limit = container.dataset.limit || '';
        fetchReviews(container, '', limit)
            .then(function(data) {
                var results = data.data || [];
                listEl.innerHTML = '';
                if (results.length === 0) {
                    listEl.innerHTML = '<p class="error-msg">該当する口コミが見つかりませんでした。</p>';
                    return;
                }
                results.forEach(function(item) {
                    listEl.appendChild(createCard(template, item, container.dataset.purpose || ''));
                });
                if (data.has_more) {
                    var loadMoreBtn = createLoadMoreButton();
                    listEl.appendChild(loadMoreBtn);
                    var currentOffset = (data.offset || 0) + results.length;
                    var pageLimit = data.limit || 3;
                    loadMoreBtn.addEventListener('click', function(e) {
                        e.preventDefault();
                        loadMoreBtn.querySelector('.review-load-more__text').innerHTML = '読み込み中...';
                        fetchReviews(container, currentOffset, pageLimit)
                            .then(function(nextJson) {
                                var nextReviews = nextJson.data || [];
                                nextReviews.forEach(function(item) {
                                    listEl.insertBefore(createCard(template, item, container.dataset.purpose || ''), loadMoreBtn);
                                });
                                currentOffset += nextReviews.length;
                                loadMoreBtn.querySelector('.review-load-more__text').innerHTML = '口コミを<br>もっと見る';
                                if (!nextJson.has_more) loadMoreBtn.remove();
                            })
                            .catch(function(error) {
                                console.error('Load more error:', error);
                                loadMoreBtn.querySelector('.review-load-more__text').innerHTML = '口コミを<br>もっと見る';
                            });
                    });
                }
            })
            .catch(function(error) {
                listEl.innerHTML = '<p class="error-msg">データの取得に失敗しました。</p>';
                console.error('Fetch error:', error);
            });
    }

    searchBtn.addEventListener('click', executeSearch);
    searchInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            executeSearch();
        }
    });

    searchEl.appendChild(searchInput);
    searchEl.appendChild(searchBtn);
    container.appendChild(searchEl);

    // カードリストコンテナ
    var listEl = document.createElement('div');
    listEl.className = 'review-list';
    container.appendChild(listEl);

    // 初期カード描画
    reviews.forEach(function(item) {
        listEl.appendChild(createCard(template, item, container.dataset.purpose || ''));
    });

    // 「もっと見る」ボタン (has_more なら表示)
    if (responseJson.has_more) {
        var loadMoreBtn = createLoadMoreButton();
        listEl.appendChild(loadMoreBtn);

        var currentOffset = (responseJson.offset || 0) + reviews.length;
        var pageLimit = responseJson.limit || 3;

        loadMoreBtn.addEventListener('click', function(e) {
            e.preventDefault();

            // ローディング表示
            loadMoreBtn.querySelector('.review-load-more__text').innerHTML = '読み込み中...';

            fetchReviews(container, currentOffset, pageLimit)
                .then(function(nextJson) {
                    var nextReviews = nextJson.data || [];
                    nextReviews.forEach(function(item) {
                        listEl.insertBefore(createCard(template, item, container.dataset.purpose || ''), loadMoreBtn);
                    });
                    currentOffset += nextReviews.length;

                    // テキストを戻す
                    loadMoreBtn.querySelector('.review-load-more__text').innerHTML = '口コミを<br>もっと見る';

                    // もうデータがなければボタン削除
                    if (!nextJson.has_more) {
                        loadMoreBtn.remove();
                    }
                })
                .catch(function(error) {
                    console.error('Load more error:', error);
                    loadMoreBtn.querySelector('.review-load-more__text').innerHTML = '口コミを<br>もっと見る';
                });
        });
    }

    // フッター注釈
    var footer = document.createElement('div');
    footer.className = 'review-footer';
    var footerText = '当サイト独自アンケートより集計';
    if (responseJson.last_modified_at) {
        var d = new Date(responseJson.last_modified_at);
        footerText += '　<br class="show_sp">最終更新: ' + d.getFullYear() + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2);
    }
    footer.innerHTML = footerText;
    container.appendChild(footer);
}

/**
 * 星分布バー1行分のHTML
 */
function buildBarHTML(star, pct) {
    return '<div class="review-bar">' +
        '<span class="review-bar__label">★' + star + '</span>' +
        '<div class="review-bar__track"><div class="review-bar__fill" style="width:' + pct + '%"></div></div>' +
        '<span class="review-bar__pct">' + pct + '%</span>' +
    '</div>';
}

/**
 * テンプレートからカードを生成
 */
function createCard(template, item, activePurpose) {
    const clone = template.content.cloneNode(true);

    // ユーザー情報
    const userInfo = [item.age, mapLabel('occupation', item.occupation), mapLabel('house_type', item.house_type)].filter(Boolean).join(' / ');
    clone.querySelector('.review-card__user-info').textContent = userInfo || '回答者';
    clone.querySelector('.review-card__date').textContent = item.review_date || '';

    // スコアテーブル
    const fieldMap = {
        rating: item.rating_total,
        speed:  item.rating_speed,
        cost:   item.rating_cost
    };

    Object.entries(fieldMap).forEach(function(entry) {
        var field = entry[0];
        var score = entry[1];
        const starsEl = clone.querySelector('.review-card__stars[data-field="' + field + '"]');
        const scoreEl = clone.querySelector('.review-card__score[data-field="' + field + '"]');
        if (starsEl) starsEl.textContent = renderStars(score);
        if (scoreEl) scoreEl.textContent = parseFloat(score).toFixed(1);
    });

    // タグ (prefecture, router は常時表示 / purpose はフィルター選択時のみ)
    const tagsEl = clone.querySelector('.review-card__tags');
    const tags = [];
    if (item.prefecture) tags.push(item.prefecture);
    if (item.router) tags.push(mapLabel('router', item.router));
    if (activePurpose) tags.push(mapLabel('purpose', activePurpose));

    tags.forEach(function(text) {
        const span = document.createElement('span');
        span.className = 'review-card__tag';
        span.textContent = text;
        tagsEl.appendChild(span);
    });

    // コメント (impression)
    const commentEl = clone.querySelector('.review-card__comment');
    commentEl.textContent = item.impression || '';

    return clone;
}

/**
 * 「もっと見る」ボタンを生成
 */
function createLoadMoreButton() {
    const a = document.createElement('a');
    a.href = '#';
    a.className = 'review-load-more';
    a.innerHTML =
        '<div class="review-load-more__circle">' +
            '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M4 12H20M20 12L13 5M20 12L13 19" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
        '</div>' +
        '<span class="review-load-more__text">口コミを<br>もっと見る</span>';
    return a;
}
